// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full-screen dark overlay with centered content */
.processing-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  animation: processingDialogAppear 0.3s ease-out;
}

@keyframes processingDialogAppear {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Content container */
.processing-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
}

/* Lantern wrapper - positioned for ::before glow */
.processing-dialog-lantern {
  position: relative;
}

/* Large, bright lantern icon (matches Studio saving overlay treatment) */
.processing-dialog-lantern-icon {
  width: 144px;
  height: 144px;
  opacity: 1;
  filter: brightness(4.0) drop-shadow(0 0 12px rgba(245, 251, 194, 0.9));
  animation: lanternGlow 2s ease-in-out infinite;
}

/* Pulsing radial glow behind the lantern */
.processing-dialog-lantern::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  width: 240px;
  height: 240px;
  background: radial-gradient(circle,
    rgba(245, 251, 194, 0.6) 0%,
    rgba(240, 226, 102, 0.4) 30%,
    rgba(240, 226, 102, 0.2) 50%,
    transparent 70%);
  border-radius: 50%;
  animation: processingGlow 2s ease-in-out infinite;
}

@keyframes processingGlow {
  0%, 100% {
    transform: translate(-50%, -60%) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: translate(-50%, -60%) scale(1.4);
    opacity: 1;
  }
}

/* Status text beneath the lantern */
.processing-dialog-text {
  color: #fff;
  font-weight: 300;
  font-size: 1.3rem;
  letter-spacing: 0.05em;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  text-align: center;
  animation: fadeInOut 2s ease-in-out infinite;
}

/* Respect reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .processing-dialog-lantern-icon {
    animation: none;
    opacity: 0.8;
  }
  .processing-dialog-lantern::before {
    animation: none;
    opacity: 0.7;
  }
  .processing-dialog-text {
    animation: none;
    opacity: 0.7;
  }
  .processing-dialog-overlay {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProcessingDialog.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,sEAAsE;EACtE,8CAA8C;AAChD;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb;;;;oBAIkB;EAClB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE;IACE,yCAAyC;IACzC,YAAY;EACd;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,sCAAsC;AACtC;EACE;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Full-screen dark overlay with centered content */\n.processing-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n  animation: processingDialogAppear 0.3s ease-out;\n}\n\n@keyframes processingDialogAppear {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Content container */\n.processing-dialog {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 2rem;\n}\n\n/* Lantern wrapper - positioned for ::before glow */\n.processing-dialog-lantern {\n  position: relative;\n}\n\n/* Large, bright lantern icon (matches Studio saving overlay treatment) */\n.processing-dialog-lantern-icon {\n  width: 144px;\n  height: 144px;\n  opacity: 1;\n  filter: brightness(4.0) drop-shadow(0 0 12px rgba(245, 251, 194, 0.9));\n  animation: lanternGlow 2s ease-in-out infinite;\n}\n\n/* Pulsing radial glow behind the lantern */\n.processing-dialog-lantern::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -60%);\n  width: 240px;\n  height: 240px;\n  background: radial-gradient(circle,\n    rgba(245, 251, 194, 0.6) 0%,\n    rgba(240, 226, 102, 0.4) 30%,\n    rgba(240, 226, 102, 0.2) 50%,\n    transparent 70%);\n  border-radius: 50%;\n  animation: processingGlow 2s ease-in-out infinite;\n}\n\n@keyframes processingGlow {\n  0%, 100% {\n    transform: translate(-50%, -60%) scale(1);\n    opacity: 0.7;\n  }\n  50% {\n    transform: translate(-50%, -60%) scale(1.4);\n    opacity: 1;\n  }\n}\n\n/* Status text beneath the lantern */\n.processing-dialog-text {\n  color: #fff;\n  font-weight: 300;\n  font-size: 1.3rem;\n  letter-spacing: 0.05em;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  text-align: center;\n  animation: fadeInOut 2s ease-in-out infinite;\n}\n\n/* Respect reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .processing-dialog-lantern-icon {\n    animation: none;\n    opacity: 0.8;\n  }\n  .processing-dialog-lantern::before {\n    animation: none;\n    opacity: 0.7;\n  }\n  .processing-dialog-text {\n    animation: none;\n    opacity: 0.7;\n  }\n  .processing-dialog-overlay {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
